var currentScreensize = checkScreensize(),
  previousScreensize;
const video = document.querySelector('#video-player');

// Check is the video is 
if (video) {
  var mobileId = video.dataset.mobileVideoId;
  var desktopId = video.dataset.desktopVideoId;
  var videoId = desktopId;
  var audio = document.getElementById("audio-control");

  if (currentScreensize == "desktop") {
    videoId = desktopId;
  } else {
    videoId = mobileId;
  }

  var player = new Vimeo.Player(video, {
    id: videoId,
    background: true
  });

  player.setVolume(0);

  audio.addEventListener("click", function () { volumeToggle(); });

  window.addEventListener('resize', () => {
    previousScreensize = currentScreensize;
    currentScreensize = checkScreensize();

    if ((previousScreensize == "desktop") && (currentScreensize == "mobile")) {

      player.loadVideo(mobileId);

    } else if ((previousScreensize == "mobile") && (currentScreensize == "desktop")) {

      player.loadVideo(desktopId);

    }
  });

  // When the video is ready to play
  player.on('play', function() {
    // Find and hide the poster
    const poster = document.querySelector('.video-poster');
    if (poster) {
      poster.classList.add('hidden');
    }
  });

  function volumeToggle() {
    player.getVolume().then(function (volume) {
      if (volume == 0) {
        player.setVolume(1);
        audio.classList.add("audio-on");
      } else {
        player.setVolume(0);
        audio.classList.remove("audio-on");
      }
    });
  }
}

function checkScreensize() {
  return (window.innerWidth >= 640 ? 'desktop' : 'mobile');
}
